import type { MediaUploadAdapter } from "./uploadAdapter";
import { buildStorageKey } from "./storageKey";
import { buildMeta, localMediaDb } from "./localMediaDb";

/**
 * Prototype adapter: persists bytes in IndexedDB under the same storageKey
 * path that cloud adapters use. publicUrl is empty — preview via getPreviewUrl.
 */
export const localIndexedDbAdapter: MediaUploadAdapter = {
  id: "local-indexeddb",

  async upload({ userId, asset, file }) {
    const storageKey = buildStorageKey({
      userId,
      kind: asset.kind,
      assetId: asset.id,
      fileName: asset.fileName,
      mimeType: asset.mimeType || file.type,
    });
    // Prefer pre-assigned canonical key from uploadService when present
    const key =
      asset.storageKey && asset.storageKey === storageKey
        ? asset.storageKey
        : storageKey;

    const meta = buildMeta({
      storageKey: key,
      userId,
      assetId: asset.id,
      kind: asset.kind,
      fileName: asset.fileName,
      mimeType: asset.mimeType || file.type || "application/octet-stream",
      sizeBytes: file.size,
    });
    await localMediaDb.put(key, file, meta);
    return { storageKey: key, publicUrl: "", meta };
  },

  async getPreviewUrl(storageKey) {
    return localMediaDb.getBlobUrl(storageKey);
  },

  async delete(storageKey) {
    await localMediaDb.delete(storageKey);
  },
};
